import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
export const RegulatoryQualityControlReportID = 14

export interface MissingRegModeOrEmployeeCategoryReportParams {
  PoolIds: number[],
  DateFrom: string,
  DateTo: string,
}

export function MissingRegModeOrEmployeeCategoryReportGetCsv(params: MissingRegModeOrEmployeeCategoryReportParams): Observable<string> {
  const requestBody: string = JSON.stringify(params)
  return ObservableFromFetch<string>("WorkforceReport/MissingRegModeOrEmployeeCategory", requestBody)
}

